import { ClassNames } from '@emotion/react';
import { Button, Dropdown, type ButtonProps, type DropDownProps } from 'antd';
import { languages } from '../model';

export const LanguageDropdown = ({
  placement,
  onSelectLanguage: onSelect,
  ...props
}: ButtonProps &
  Pick<DropDownProps, 'placement'> & {
    onSelectLanguage?: (language: string) => void;
  }) => {
  return (
    <ClassNames>
      {({ css }) => (
        <Dropdown
          trigger={['click']}
          classNames={{
            root: css`
              .ant-dropdown-menu {
                max-height: 192px;
              }
            `,
          }}
          menu={{
            items: languages.map((lang) => ({
              key: lang,
              label: lang,
              onClick: () => onSelect?.(lang),
            })),
          }}
          placement={placement}
        >
          <Button {...props}>选择语种</Button>
        </Dropdown>
      )}
    </ClassNames>
  );
};
